import { BorderedBox } from "pages/LessonRecord/components";
import {
	imageModalReducerActions,
	useImageModalContext,
} from "contexts/imageModal";
import { ProtectedImg } from "components";
import { imageTypes } from "pages/LessonRecord/constants";

export const Classwork = ({ lessonFiles }) => {
	const { dispatch: imageModalDispatch } = useImageModalContext();
	const classwork = lessonFiles?.filter(
		(lessonFile) => lessonFile.type === imageTypes.CLASSWORK
	);

	return (
		<BorderedBox className="align-items-center">
			{classwork?.length ? (
				classwork?.map((lessonFile, index) => (
					<div
						className="col-6 col-sm-4 col-md-3 col-lg-2"
						key={lessonFile.id}
					>
						<ProtectedImg
							src={lessonFile.filepath || lessonFile.data}
							className="img-fluid rounded"
							onClick={() =>
								imageModalDispatch({
									type: imageModalReducerActions.SHOW,
									payload: lessonFile.filepath,
								})
							}
						/>
					</div>
				))
			) : (
				<div className="ml-2 d-flex align-items-center">
					No in class photos
				</div>
			)}
		</BorderedBox>
	);
};
